module.exports = __webpack_public_path__ + "static/media/img-5.266125da.png";